// extracted by mini-css-extract-plugin
export default {"budget":"NavigationPanel_budget__yjJG6","relatedLinks":"NavigationPanel_relatedLinks__HUQ-1","theme":"NavigationPanel_theme__hooBG"};